import { StandortStore } from "domain/Types";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

export const useStandortStore = create<StandortStore>()(
  devtools(
    (set) => ({
      isValidStandort: undefined,
      actions: {
        setIsValidStandort: (isValidStandort: boolean) => set((_) => ({ isValidStandort })),
      },
    }),
    {
      name: "StandortStore",
    }
  )
);

export const useStandortStoreActions = () => useStandortStore((state) => state.actions);
